import React, {Component} from 'react'
import {envHttpUrl} from '../../http/globalMethod'
import {withRouter} from "react-router-dom";

class LcPageSystem extends Component {
    state = {
        erpUrl:`${window.location.protocol}${envHttpUrl().erpUrl}`,
        defaultTab:''
    }
    componentDidMount(){
        const  locationQuery = new URLSearchParams(this.props.history.location.search)
        const defaultTab = locationQuery.get('url')?locationQuery.get('url'):'';
        this.setState({
            defaultTab
        })
        console.log('defaultTab',defaultTab)

        this.unlisten = this.props.history.listen((location) => {
            console.log('路由变化:', location.pathname);
            if(this.props.location.pathname!==location.pathname){
                console.log('修改iframe 路由变化:', location.pathname);
                const  locationQuery = new URLSearchParams(location.search)
                this.setState({
                    defaultTab:locationQuery.get('url')?locationQuery.get('url'):''
                })
            }


        });
        window.addEventListener('message', (event)=> {
            if( event.data.url){
                console.log('接受连接 from iframe:',event.origin, event.data.url);
                console.log(window.location)
                let url = encodeURIComponent(event.data.url);
                this.props.history.replace('/portal/lcpagesystem?url='+url)
                // history.push('/portal/lcpagesystem?url='+url, { replace: true });

            }
        });

    }
    componentWillUnmount() {
        this.unlisten();
    }
    render() {


        return (
            <div style={{boxSizing:'border-box',height:'100%',paddingBottom:'10px'}} id='erp-container'>
                <iframe id={'myFrame'} style={{width:'100%',height:'100%',border:'none'}} src={this.state.defaultTab}></iframe>
            </div>

        )
    }
}
export default withRouter(LcPageSystem)

